import _ from "underscore";
import ProspectService from "@/services/prospect/prospectService";
import { RootState } from "..";
import { Module } from "vuex";
interface ProspectQuestionModuleState {
  prospectQuestionGroups: any[];
  currQuestionGroupId: string;
  currQuestionGroupInfo: any;
  currQuestionGroupIndex: number;
  totalQuestionGroups: number;

  currQuestionInfo: any;
  currQuestionId: string;
  currQuestionAnswer: string;
  currQuestionDisplayType: string;
  currQuestionNo: any;
  currQuestionIndex: any;
  editQuestionId: string;
  currGroupQuestions: any[];
  isAnswerUpdated: boolean;
  isAnswerEmpty: boolean;
}

const prospectQuestionModule: Module<ProspectQuestionModuleState, RootState> = {
  namespaced: true,
  state: () => ({
    prospectQuestionGroups: [],
    currQuestionGroupId: "",
    currQuestionGroupInfo: {},
    currQuestionGroupIndex: -1,
    totalQuestionGroups: 0,

    currQuestionInfo: {},
    currQuestionId: "",
    currQuestionAnswer: "",
    currQuestionDisplayType: "",
    currQuestionNo: 0,
    currQuestionIndex: -1,
    editQuestionId: "",
    currGroupQuestions: [],
    isAnswerUpdated: false,
    isAnswerEmpty: true,
  }),

  getters: {},
  mutations: {
    SET_PROS_QUES_GROUPS: (state: any, list: Array<any>) => {
      state.prospectQuestionGroups = list;
      state.totalQuestionGroups = list.length;
    },
    SET_CUSTOM_QG_INDEX: (state: any, indexVal: number) => {
      if (
        indexVal >= 0 &&
        state.prospectQuestionGroups &&
        state.prospectQuestionGroups.length > 0 &&
        indexVal <= state.prospectQuestionGroups.length - 1
      ) {
        state.currQuestionGroupIndex = indexVal;
        state.isAnswerUpdated = false;
      }
    },
    SET_QG_NEXT_INDEX: (state: any) => {
      if (
        state.prospectQuestionGroups &&
        state.prospectQuestionGroups.length > 0 &&
        state.prospectQuestionGroups.length - 1 > state.currQuestionGroupIndex
      ) {
        state.currQuestionGroupIndex =
          parseInt(state.currQuestionGroupIndex) + 1;
        state.isAnswerUpdated = false;
      }
    },
    SET_QG_PREVIOUS_INDEX: (state: any) => {
      if (
        state.prospectQuestionGroups &&
        state.prospectQuestionGroups.length > 0 &&
        state.prospectQuestionGroups.length - 1 >=
          state.currQuestionGroupIndex &&
        state.currQuestionGroupIndex > 0
      ) {
        state.currQuestionGroupIndex =
          parseInt(state.currQuestionGroupIndex) - 1;
        state.currQuestionIndex = -1;
        state.isAnswerUpdated = false;
      }
    },
    SET_INDEX_QUESTION_GROUP: (state: any) => {
      if (
        state.prospectQuestionGroups.length > state.currQuestionGroupIndex &&
        state.currQuestionGroupIndex >= 0
      ) {
        state.currQuestionGroupInfo =
          state.prospectQuestionGroups[state.currQuestionGroupIndex];
        state.currQuestionIndex = -1;
        state.currQuestionInfo = {};
        state.currGroupQuestions = [];
        state.isAnswerUpdated = false;
        state.isAnswerEmpty = true;

        if (
          state.currQuestionGroupInfo &&
          state.currQuestionGroupInfo.prospect_questions &&
          state.currQuestionGroupInfo.prospect_questions.length > 0
        ) {
          // To make the one-and-only question as active question.
          if (state.currQuestionGroupInfo.prospect_questions.length == 1) {
            state.currQuestionIndex = 0;
            const nextQstnInfo =
              state.currQuestionGroupInfo.prospect_questions[
                state.currQuestionIndex
              ];
            nextQstnInfo.isAnswered = false;
            state.currQuestionGroupInfo.prospect_questions[
              state.currQuestionIndex
            ] = nextQstnInfo;
            state.currQuestionInfo = Object.assign({}, nextQstnInfo);
          } else {
            let k, kNext;
            for (
              k = 0;
              k < state.currQuestionGroupInfo.prospect_questions.length;
              k++
            ) {
              if (
                !state.currQuestionGroupInfo.prospect_questions[k].isAnswered
              ) {
                state.currQuestionIndex = k;
                state.currQuestionInfo =
                  state.currQuestionGroupInfo.prospect_questions[k];
                kNext = k;
                k = state.currQuestionGroupInfo.prospect_questions.length;
              }
            }

            if (
              kNext !== "" &&
              kNext <= state.currQuestionGroupInfo.prospect_questions.length
            ) {
              const remList = state.currQuestionGroupInfo.prospect_questions;
              for (let rm = kNext; rm < remList.length; rm++) {
                remList[rm].isAnswered = false;
              }
              state.currQuestionGroupInfo.prospect_questions = remList;
            }

            setTimeout(() => {
              state.currGroupQuestions =
                state.currQuestionGroupInfo.prospect_questions;
            }, 1);
          }
        }
      }
    },
    SET_NEXT_QSTN_INDEX: (state: any) => {
      if (
        state.currQuestionGroupInfo &&
        state.currQuestionGroupInfo.prospect_questions &&
        state.currQuestionGroupInfo.prospect_questions.length > 0 &&
        state.currQuestionGroupInfo.prospect_questions.length - 1 >
          state.currQuestionIndex
      ) {
        state.currQuestionIndex = parseInt(state.currQuestionIndex) + 1;
      }
    },
    SET_ON_NEXT: (state: any) => {
      if (
        state.currQuestionIndex >= 0 &&
        state.currQuestionGroupInfo &&
        state.currQuestionGroupInfo.prospect_questions &&
        state.currQuestionIndex <
          state.currQuestionGroupInfo.prospect_questions.length - 1
      ) {
        state.currQuestionIndex = parseInt(state.currQuestionIndex) + 1;
        const nextQstnInfo =
          state.currQuestionGroupInfo.prospect_questions[
            state.currQuestionIndex
          ];
        nextQstnInfo.isAnswered = false;
        state.currQuestionGroupInfo.prospect_questions[
          state.currQuestionIndex
        ] = nextQstnInfo;
        state.currQuestionInfo = Object.assign({}, nextQstnInfo);

        if (
          state.currQuestionIndex >= 1 &&
          state.currQuestionIndex <
            state.currQuestionGroupInfo.prospect_questions.length
        ) {
          state.currGroupQuestions =
            state.currQuestionGroupInfo.prospect_questions.slice(
              0,
              state.currQuestionIndex,
            );
        } else {
          state.currGroupQuestions = [];
        }
      } else {
        if (
          state.currQuestionGroupIndex <
          state.prospectQuestionGroups.length - 1
        ) {
          state.currQuestionInfo = {};
          state.isAnswerUpdated = false;

          // Set first QG info & first que.info.
          if (state.currQuestionIndex < 0) {
            state.currQuestionGroupIndex = 0;
          } else {
            state.currQuestionGroupIndex =
              parseInt(state.currQuestionGroupIndex) + 1;
          }
          state.currQuestionGroupInfo =
            state.prospectQuestionGroups[state.currQuestionGroupIndex];
          state.currQuestionIndex = 0;
          state.currGroupQuestions = [];

          if (
            state.currQuestionGroupInfo &&
            state.currQuestionGroupInfo.prospect_questions &&
            state.currQuestionGroupInfo.prospect_questions.length > 0
          ) {
            const nextQstnInfo: any = Object.assign(
              {},
              state.currQuestionGroupInfo.prospect_questions[
                state.currQuestionIndex
              ],
            );
            nextQstnInfo.isAnswered = false;
            state.currQuestionInfo = Object.assign({}, nextQstnInfo);
            state.currQuestionGroupInfo.prospect_questions[
              state.currQuestionIndex
            ] = nextQstnInfo;
          }
        }
      }
      state.editQuestionId = "";
    },
    SET_QUESTION_ANSWER: (state: any, val: any) => {
      if (state.currQuestionIndex >= 0 && state.currQuestionGroupIndex >= 0) {
        const currQstInfo = state.currQuestionInfo;
        let ansVals: any = [];

        if (val && val.ans) {
          if (Array.isArray(val.ans)) {
            ansVals = val.ans;
          } else {
            ansVals = [val.ans];
          }
        }

        if (val && val.callFrom && val.callFrom === "SKIP") {
          currQstInfo.isAnswered = false;
        } else {
          currQstInfo.isAnswered = true;

          if (
            !state.isAnswerUpdated &&
            JSON.stringify(currQstInfo.values) != JSON.stringify(ansVals)
          ) {
            state.isAnswerUpdated = true;
            if (state.isAnswerEmpty && ansVals.length > 0) {
              state.isAnswerEmpty = false;
            }
          }
        }

        currQstInfo.values = ansVals;

        if (
          state.currQuestionGroupInfo &&
          state.currQuestionGroupInfo.prospect_questions &&
          state.currQuestionGroupInfo.prospect_questions.length > 0
        ) {
          state.currQuestionGroupInfo.prospect_questions[
            state.currQuestionIndex
          ] = currQstInfo;
          state.prospectQuestionGroups[state.currQuestionGroupIndex] =
            state.currQuestionGroupInfo;
        }
      }
    },
    SET_EDIT_QUESTION_INFO: (state: any, val: any) => {
      if (val && val.id) {
        const editQstnIndex = _.findIndex(
          state.currQuestionGroupInfo.prospect_questions,
          { id: val.id },
        );
        if (editQstnIndex >= 0) {
          state.currQuestionIndex = editQstnIndex;
          state.editQuestionId = editQstnIndex;
          state.currQuestionInfo = {};

          state.currQuestionInfo = Object.assign(
            {},
            state.currQuestionGroupInfo.prospect_questions[editQstnIndex],
          );

          if (
            state.currQuestionIndex >= 1 &&
            state.currQuestionIndex <
              state.currQuestionGroupInfo.prospect_questions.length
          ) {
            state.currGroupQuestions =
              state.currQuestionGroupInfo.prospect_questions.slice(
                0,
                state.currQuestionIndex,
              );
          } else {
            state.currGroupQuestions = [];
          }
        }
      }
    },
    SAVE_CURR_GROUP_INFO: (state: any) => {
      if (state.currQuestionIndex >= 0 && state.currQuestionGroupInfo) {
        const saveGrpObj: any = {};
        saveGrpObj.name = state.currQuestionGroupInfo.id;
        saveGrpObj.prospect_questions = [];

        const grpQstns: any[] = [];
        for (const qs of state.currQuestionGroupInfo.prospect_questions) {
          const qstnObj: any = {};
          qstnObj.name = qs.id;
          qstnObj.values = qs.values;
          grpQstns.push(qstnObj);
        }
        saveGrpObj.prospect_questions = grpQstns;
        return { prospect_question_group: saveGrpObj };
      }
    },
    CHECK_ANY_QUESTNS_NEXT: (state: any) => {
      return new Promise((resolve) => {
        if (
          state.currQuestionGroupInfo.prospect_questions.length - 1 ==
          state.currQuestionIndex
        ) {
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },
    RESET_TO_DEFAULTS: (state: any) => {
      state.currQuestionGroupIndex = -1;
      state.currQuestionGroupInfo = {};
      state.currQuestionIndex = -1;
      state.editQuestionId = "";
      state.prospectQuestionGroups = [];
      state.currQuestionInfo = {};
      state.currGroupQuestions = [];
    },
  },
  actions: {
    setProsQuesGroups: async (
      { commit }: { commit: any },
      list: Array<any>,
    ) => {
      await commit("SET_PROS_QUES_GROUPS", list);
    },
    setCustomQG: async ({ commit }: { commit: any }, indexVal: number) => {
      await commit("SET_CUSTOM_QG_INDEX", indexVal);
      await commit("SET_INDEX_QUESTION_GROUP");
    },
    setQGNextIndex: ({ commit }: { commit: any }) => {
      commit("SET_QG_NEXT_INDEX");
    },
    setPreviousIndex: ({ commit }: { commit: any }) => {
      commit("SET_QG_PREVIOUS_INDEX");
    },
    setIndexQuestionGroup: ({ commit }: { commit: any }) => {
      commit("SET_INDEX_QUESTION_GROUP");
    },
    setNextQuestionGroup: async ({ commit }: { commit: any }) => {
      await commit("SET_QG_NEXT_INDEX");
      await commit("SET_INDEX_QUESTION_GROUP");
    },
    setPreviousQuestionGroup: async ({ commit }: { commit: any }) => {
      await commit("SET_QG_PREVIOUS_INDEX");
      await commit("SET_INDEX_QUESTION_GROUP");
    },
    checkAndSetNext: async ({ commit }: { commit: any }) => {
      await commit("SET_ON_NEXT");
    },
    setQuestionAnswer: async ({ commit }: { commit: any }, val: any) => {
      await commit("SET_QUESTION_ANSWER", val);
    },
    setEditQuestionInfo: async ({ commit }: { commit: any }, val: any) => {
      await commit("SET_EDIT_QUESTION_INFO", val);
    },
    checkAnyQuestionsNext: async ({ commit }: { commit: any }) => {
      return await commit("CHECK_ANY_QUESTNS_NEXT");
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    saveCurrGroupInfo: async ({ commit }: { commit: any }, data: any) => {
      return new Promise((resolve, reject) => {
        const prospectService = new ProspectService();
        prospectService.saveProspectQuestions(data).then(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          },
        );
      });
    },
    setAllToDefaultData: async ({ commit }: { commit: any }) => {
      await commit("RESET_TO_DEFAULTS");
    },
  },
};

export default prospectQuestionModule;
